import { useRef } from "react";
import { motion } from "framer-motion";
import data from "../../data/index.json";

const categories = [
  { label: "Frontend", match: ["HTML", "CSS", "JavaScript", "React", "Tailwind", "Bootstrap", "MUI", "Next.js", "jQuery"] },
  { label: "Backend", match: ["PHP", "Nest Js", "PostgreSQL", "MySQL", "Python", "Strapi", "Supabase", "OpenAI"] },
  { label: "Tools", match: ["Git", "Docker", "Postman", "Hostiger", "Typescript"] },
  { label: "Mobile", match: ["Flutter", "Android Studio"] },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.4, ease: "easeOut" } },
};

function TiltCard({ children }) {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const card = ref.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * -8;
    const rotateY = ((x - centerX) / centerX) * 8;
    card.style.transform = `perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
  };

  const handleMouseLeave = () => {
    if (ref.current) {
      ref.current.style.transform = "perspective(600px) rotateX(0) rotateY(0) scale(1)";
    }
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className="transition-transform duration-100 ease-out"
      style={{ transformStyle: "preserve-3d" }}
    >
      {children}
    </div>
  );
}

export default function MySkills() {
  return (
    <section id="mySkills" className="section-padding bg-gray-50 dark:bg-black/50">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          className="text-center mb-16"
        >
          <h2 className="section-title">My Tech Stack</h2>
          <p className="section-subtitle mx-auto">
            Technologies I work with daily to build modern applications
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {categories.map((category) => (
            <motion.div
              key={category.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5 }}
              className="bento-glass-card"
            >
              <h3 className="font-display text-lg font-bold text-black dark:text-white mb-6">
                {category.label}
              </h3>
              <motion.div
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="grid grid-cols-2 sm:grid-cols-3 gap-4"
              >
                {data?.skills
                  ?.filter((skill) =>
                    category.match.some((m) =>
                      skill.title.toLowerCase().includes(m.toLowerCase())
                    )
                  )
                  .map((skill) => (
                    <TiltCard key={skill.id}>
                      <motion.div
                        variants={item}
                        className="flex flex-col items-center gap-2 p-3 rounded-xl bg-white/50 hover:bg-white
                                   dark:bg-white/5 dark:hover:bg-white/10
                                   transition-all duration-200 cursor-default group"
                      >
                        <div className="w-10 h-10 flex items-center justify-center
                                        group-hover:scale-110 transition-transform duration-200">
                          <img
                            src={skill.src}
                            alt={skill.title}
                            className="max-w-full max-h-full object-contain"
                          />
                        </div>
                        <span className="font-body text-xs font-medium text-black/70 dark:text-white/70 text-center leading-tight">
                          {skill.title}
                        </span>
                      </motion.div>
                    </TiltCard>
                  ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
